export default "__VITE_ASSET__c9ae7316__"